var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChartIconNumber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42846",
    "data-name": "Group 42846",
    transform: "translate(-700 -322)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42632",
    "data-name": "Group 42632",
    transform: "translate(-10 -6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42612",
    "data-name": "Group 42612",
    transform: "translate(706 325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6222",
    "data-name": "Rectangle 6222",
    transform: "translate(4 3)",
    fill: "#fff",
    stroke: "#dedede",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 3.5,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Donut_chart",
    "data-name": "Donut chart",
    transform: "translate(553 92.999)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 28,
    height: 28,
    transform: "translate(148 231.001)",
    fill: "#e0e0e0",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_List_Numbered_120493",
    "data-name": "noun_List Numbered_120493",
    transform: "translate(151.5 235.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10081",
    "data-name": "Rectangle 10081",
    transform: "translate(8)",
    fill: "none",
    stroke: "#85888a",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 7,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 12,
    height: 6,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10082",
    "data-name": "Rectangle 10082",
    transform: "translate(8 11)",
    fill: "none",
    stroke: "#85888a",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 7,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 12,
    height: 6,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_1_2",
    "data-name": "1 2",
    transform: "translate(-0.5 7.026)",
    fill: "#85888a",
    fontSize: 10,
    fontFamily: "OpenSans-Bold, Open Sans",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "2")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIconNumber);
export default __webpack_public_path__ + "static/media/chart-icon-number.2cf04e91.svg";
export { ForwardRef as ReactComponent };